<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Budget Plan {{ detail.title }}</h2>
                <!-- Text -->
                <p class="text-muted mb-md-0">
                  <small>Version {{ detail?.version }} </small>
                </p>
                <p class="text-muted mb-md-0" v-if="updatedAt != ''">
                  <small>Last update : {{ updatedAt }} </small>
                </p>
                <p class="text-muted mb-md-0" v-if="updatedAt != ''">
                  <small>by {{ updatedBy }}</small>
                </p>
              </div>
              <div class="col-12 col-md-3 col-xl-5">
                <div class="d-flex flex-row-reverse">
                  <button class="btn btn-primary" @click="cloning()" v-if="canCloned">Clone</button>
                  <button
                    class="btn btn-info mr-2"
                    type="button"
                    @click="toogleApprove(detail.id, detail.approved)"
                    v-if="!detail.approved && canApprovedDissapproved"
                  >
                    Approve
                  </button>
                  <button
                    class="btn btn-outline-info mr-2"
                    type="button"
                    @click="toogleApprove(detail.id, detail.approved)"
                    v-if="detail.approved && canApprovedDissapproved"
                  >
                    Dissapprove
                  </button>
                  <template v-if="!detail.approved">
                    <button
                      class="btn btn-outline-info mr-2"
                      type="button"
                      @click="toogleLock(detail.id, detail.locked)"
                      v-if="!detail.locked && canLockUnlock"
                    >
                      Lock
                    </button>
                    <button
                      class="btn btn-outline-info mr-2"
                      type="button"
                      @click="toogleLock(detail.id, detail.locked)"
                      v-if="detail.locked && canLockUnlock"
                    >
                      Unlock
                    </button>
                  </template>
                  <button class="btn btn-outline-primary mr-2" type="button" @click="historyBack()">Back</button>
                </div>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <div class="row" v-if="isLoading">
          <div class="col-12">
            <div class="card">
              <div class="row row-col-5 gx-3 gy-5 card-body">
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <div class="card-body row">
                <div class="col-12 col-md-6">
                  <div class="card">
                    <div class="row gx-3 gy-5 card-body">
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="card">
                    <div class="card-body d-flex flex-column">
                      <div class="mt-2">
                        <b-skeleton animation="wave" width="100%"></b-skeleton>
                        <b-skeleton animation="wave" width="100%"></b-skeleton>
                      </div>
                      <div class="mt-2">
                        <b-skeleton animation="wave" width="100%"></b-skeleton>
                        <b-skeleton animation="wave" width="100%"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card"></div>
          </div>
        </div>
        <div class="row" v-if="!isLoading">
          <div class="col-12">
            <div class="card">
              <div class="row row row-cols-1 row-cols-md-2 row-cols-xl-5 gx-5 gy-3 card-body">
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-clipboard"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Budget title</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detail.title }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-home"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Department</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detail.fund_center?.department_code }} - {{ detail?.departments }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-credit-card"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Fund Center</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detail.fund_center?.fund_center }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-calendar"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Year</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detail.year }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-dollar-sign"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Total OPEX + CAPEX</h4>
                      <small class="text-body-secondary"
                        ><span> {{ budgetPlanTotal }}</span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <div class="card-body row">
                <div class="col-12 col-md-6">
                  <div class="card">
                    <div class="row gx-3 gy-5 card-body">
                      <div class="col-12 col-lg-6">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Created At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ createdAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Created By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ createdBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Updated At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ updatedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Updated By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ updatedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail.locked">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Locked At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ lockedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail.locked">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Locked By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ lockedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.all_version?.length != detail.version">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Cloned At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ clonedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.all_version?.length != detail.version">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Cloned By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ clonedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.histories?.some((h) => h.activity == 'APPROVE')">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Approved At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ approvedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.histories?.some((h) => h.activity == 'APPROVE')">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Approved By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ approvedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.histories?.some((h) => h.activity == 'DISAPPROVE')">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Disapproved At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ disapprovedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.histories?.some((h) => h.activity == 'DISAPPROVE')">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Disapproved By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ disapprovedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="card">
                    <div class="card-body d-flex flex-column">
                      <template v-for="version in detail.all_version">
                        <a v-if="id != version.id" class="btn mb-3 btn-outline-primary" @click="goToDetail(version.id)"
                          >Version {{ version.version }} <span class="ml-3 fe fe-check-circle" v-if="version.approved" title="Approved"></span
                        ></a>
                        <a v-else class="btn mb-3 btn-primary"
                          >Version {{ version.version }} <span class="ml-3 fe fe-check-circle" v-if="version.approved" title="Approved"></span
                        ></a>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <b-tabs pills card fill>
                <b-tab :title="`OPEX : Rp. ${convertNumber(detail.opex_total)}`">
                  <div style="overflow: auto">
                    <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                      <thead>
                        <tr>
                          <!-- <th style="width: 150px" v-if="role_id == 'Super Admin' || role_id == 'Admin'">Action</th> -->
                          <th style="width: 100px">Code</th>
                          <th style="width: 100px">GL</th>
                          <th style="width: 350px">Budget Item</th>
                          <th style="width: 150px">January</th>
                          <th style="width: 150px">February</th>
                          <th style="width: 150px">March</th>
                          <th style="width: 150px">April</th>
                          <th style="width: 150px">May</th>
                          <th style="width: 150px">June</th>
                          <th style="width: 150px">July</th>
                          <th style="width: 150px">August</th>
                          <th style="width: 150px">September</th>
                          <th style="width: 150px">October</th>
                          <th style="width: 150px">November</th>
                          <th style="width: 150px">December</th>
                          <th style="width: 150px">Total</th>
                        </tr>
                      </thead>
                      <tbody v-for="(item, index) in detail.opex" :key="index">
                        <tr class="opex-first">
                          <!-- <td v-if="role_id == 'Super Admin' || role_id == 'Admin'"></td> -->
                          <td class="bg-gray">{{ item.account.code }}</td>
                          <td class="bg-gray"></td>
                          <td class="bg-gray">
                            {{ item.account.account }}
                          </td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.jan) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.feb) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.mar) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.apr) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.may) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.jun) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.jul) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.aug) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.sep) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.oct) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.nov) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.dec) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.total) }}</td>
                        </tr>

                        <tr v-for="(list, indx) in item.opex_item" :key="indx" class="opex">
                          <!-- <td v-if="role_id == 'Super Admin' || role_id == 'Admin'">
														<b-button variant="info" size="sm" block @click="sharePlan(list.id, 'plan_item_item_opex')">
															<span class="fe fe-share-2 mr-2"></span>Share</b-button
														>
													</td> -->
                          <td>{{ list.budget_item.item }}</td>
                          <td>{{ list.opex_gl?.gl_code }}</td>
                          <td v-b-popover.hover.top="'Click here for more detail'" style="cursor: pointer" @click="detailBudget(list)">
                            {{ list.budget_item.budget_item }}
                            <span class="float-end fe fe-maximize-2"></span>
                          </td>
                          <td>Rp. {{ convertNumber(list.summary.jan) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.feb) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.mar) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.apr) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.may) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.jun) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.jul) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.aug) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.sep) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.oct) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.nov) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.dec) }}</td>
                          <td>Rp. {{ convertNumber(list.summary.total) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-tab>
                <b-tab :title="`CAPEX : Rp. ${convertNumber(detail.capex_total)}`">
                  <div style="overflow: auto">
                    <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                      <thead>
                        <tr class="capex">
                          <!-- <th style="width: 150px" v-if="role_id == 'Super Admin' || role_id == 'Admin'">Action</th> -->
                          <th style="width: 150px">Fund</th>
                          <th style="width: 150px">GL</th>
                          <th style="width: 350px">Budget Item</th>
                          <th style="width: 350px">Description</th>
                          <th style="width: 150px">January</th>
                          <th style="width: 150px">February</th>
                          <th style="width: 150px">March</th>
                          <th style="width: 150px">April</th>
                          <th style="width: 150px">May</th>
                          <th style="width: 150px">June</th>
                          <th style="width: 150px">July</th>
                          <th style="width: 150px">August</th>
                          <th style="width: 150px">September</th>
                          <th style="width: 150px">October</th>
                          <th style="width: 150px">November</th>
                          <th style="width: 150px">December</th>
                          <th style="width: 150px">Total</th>
                        </tr>
                      </thead>
                      <tbody v-for="(item, index) in detail.capex" :key="index">
                        <tr class="capex-gl">
                          <!-- <td v-if="role_id == 'Super Admin' || role_id == 'Admin'">
														<b-button variant="info" size="sm" block @click="sharePlan(item.id, 'plan_item_capex')">
															<span class="fe fe-share-2 mr-2"></span>Share</b-button
														>
													</td> 
													</td>-->
                          <td class="bg-gray">{{ item?.fund?.fund }}</td>
                          <td class="bg-gray">{{ item.capex_gl.gl_code }}</td>
                          <td class="bg-gray">{{ item.account.account }}</td>
                          <td class="bg-gray"></td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.jan) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.feb) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.mar) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.apr) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.may) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.jun) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.jul) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.aug) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.sep) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.oct) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.nov) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.dec) }}</td>
                          <td class="bg-gray">Rp. {{ convertNumber(item.summary.total) }}</td>
                        </tr>

                        <tr v-for="(list, indx) in item.budget" :key="indx" class="capex">
                          <!-- <td v-if="role_id == 'Super Admin' || role_id == 'Admin'"></td> -->
                          <td></td>
                          <td></td>
                          <td>{{ list.name }}</td>
                          <td>{{ list.description }}</td>
                          <td>Rp. {{ convertNumber(list.jan) }}</td>
                          <td>Rp. {{ convertNumber(list.feb) }}</td>
                          <td>Rp. {{ convertNumber(list.mar) }}</td>
                          <td>Rp. {{ convertNumber(list.apr) }}</td>
                          <td>Rp. {{ convertNumber(list.may) }}</td>
                          <td>Rp. {{ convertNumber(list.jun) }}</td>
                          <td>Rp. {{ convertNumber(list.jul) }}</td>
                          <td>Rp. {{ convertNumber(list.aug) }}</td>
                          <td>Rp. {{ convertNumber(list.sep) }}</td>
                          <td>Rp. {{ convertNumber(list.oct) }}</td>
                          <td>Rp. {{ convertNumber(list.nov) }}</td>
                          <td>Rp. {{ convertNumber(list.dec) }}</td>
                          <td>Rp. {{ convertNumber(list.total) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>

      <!-- Body -->
    </div>
    <!-- / .header -->
    <b-modal size="xl" id="modalBudget" centered :title="listBudget ? listBudget.budget_item.budget_item : '-'" hide-footer>
      <div class="row">
        <div class="form-group col-12 col-md-6" v-if="!canTransferTask">
          <label>Filter Department Origin</label>
          <v-select class="w-md-auto" label="department_name" :reduce="(e) => e.id" :options="filterDepartmentOptions" v-model="filter_fund_center">
            <template slot="option" slot-scope="option">
              {{ `${option.fund_center} - ${option.department_name}` }}
            </template>

            <template slot="selected-option" slot-scope="option">
              {{ `${option.fund_center} - ${option.department_name}` }}
            </template>
          </v-select>
        </div>
      </div>
      <div style="overflow: auto">
        <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
          <thead>
            <tr>
              <!-- <th style="width: 150px;">GL</th> -->
              <!-- <th style="width: 100px;">TT</th> -->
              <th style="width: 150px" v-if="listBudget?.budget_item?.budget_item == 'IT Expense' && canTransferTask">Action</th>
              <th style="width: 300px">Budget Task</th>
              <th style="width: 300px">Description</th>
              <th style="width: 150px">January</th>
              <th style="width: 150px">February</th>
              <th style="width: 150px">March</th>
              <th style="width: 150px">April</th>
              <th style="width: 150px">May</th>
              <th style="width: 150px">June</th>
              <th style="width: 150px">July</th>
              <th style="width: 150px">August</th>
              <th style="width: 150px">September</th>
              <th style="width: 150px">October</th>
              <th style="width: 150px">November</th>
              <th style="width: 150px">December</th>
              <th style="width: 150px">Total</th>
            </tr>
          </thead>
          <!-- {{ listBudget.plan_item_opex_id }} -->
          <tbody>
            <tr v-for="(item, index) in listBudgetItems" :key="index">
              <td v-if="listBudget?.budget_item?.budget_item == 'IT Expense' && canTransferTask">
                <b-button variant="info" size="sm" block @click="transfer(item.id)"><span class="fe fe-scissors mr-2"></span>Transfer</b-button>
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'jan') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.jan) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'feb') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.feb) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'mar') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.mar) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'apr') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.apr) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'may') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.may) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'jun') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.jun) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'jul') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.jul) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'aug') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.aug) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'sep') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.sep) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'oct') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.oct) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'nov') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.nov) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'dec') }}</span
                  >
                </div>
                Rp. {{ convertNumber(item.dec) }}
              </td>
              <td>Rp. {{ convertNumber(item.total) }}</td>
            </tr>
            <tr>
              <!-- <td>{{ item.name }}</td> -->
              <td :colspan="listBudget?.budget_item?.budget_item == 'IT Expense' && canTransferTask ? 3 : 2" class="text-center font-weight-bold">
                Total:
              </td>
              <!-- {{ listBudget.summary ? listBudget.summary.jan : '0' }}/ -->
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.jan : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.feb : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.mar : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.apr : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.may : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.jun : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.jul : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.aug : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.sep : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.oct : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.nov : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.dec : '0') }}
              </td>
              <td>
                Rp.
                {{ convertNumber(listBudget.summary ? listBudget.summary.total : '0') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal size="xl" id="modal-share" centered title="Share Plan" hide-footer>
      <div class="d-flex justify-content-end mb-3 mt-3 mr-3">
        <label class="align-self-center mb-0 mr-3">Search User</label>
        <b-form-input class="w-auto" v-model="body.search" placeholder="Type Here..." @change="getListUser()"> </b-form-input>
      </div>
      <table class="table table-sm table-bordered table-striped table-hover p-0" v-if="listViewer">
        <thead class="table-light">
          <tr>
            <td>Name</td>
            <td>Division</td>
            <td>Department</td>
            <td style="width: 150px" class="text-center">Share</td>
          </tr>
        </thead>
        <tbody v-for="(item, index) in listViewer" :key="index">
          <tr>
            <td>{{ item ? item.fullname : '-' }}</td>
            <td>{{ item.divisi ? item.divisi : '-' }}</td>
            <td>{{ item.department ? item.department : '-' }}</td>
            <td class="text-center">
              <b-button v-if="item.shared" variant="danger" size="sm" block @click="unshares(item.shared.id)"
                ><span class="fe fe-share-2"></span> Unshare</b-button
              >
              <b-button v-else variant="info" size="sm" block @click="shares(item.id)"><span class="fe fe-share-2"></span> Share</b-button>
              <!-- <div class="form-check">
                <input class="form-check-input" type="checkbox" id="checklistTwo" @input="shares(item.id)">
              </div> -->
            </td>
          </tr>
        </tbody>
      </table>
      <b-skeleton-table v-else :rows="1" :columns="8" :table-props="{ bordered: true, striped: true }"> </b-skeleton-table>
    </b-modal>

    <b-modal size="lg" id="modal-transfer" centered title="Transfer Budget Task" hide-footer>
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <label>Select Department to Transfer</label>
          <v-select
            name="department"
            class="w-md-auto"
            label="department_name"
            v-validate="'required'"
            :options="listDepartment"
            :reduce="(e) => e.id"
            @input="selectFundCenter"
            v-model="transferTask.fund_center_id"
          ></v-select>
          <span class="text-sm text-danger" v-show="errors.has('department')">Please select department to transfer</span>
        </div>
        <div class="form-group col-12 col-md-6">
          <label>Select Budget Plan</label>
          <v-select
            name="plan"
            class="w-md-auto"
            label="title"
            v-validate="'required'"
            :options="listPlan"
            @input="selectPlan"
            v-model="selectedPlan"
            :disabled="!transferTask.fund_center_id"
          ></v-select>
          <span class="text-sm text-danger" v-show="errors.has('plan')">Plan is required</span>
        </div>
        <div class="form-group col-12 col-md-6">
          <label>Version</label>
          <input type="text" class="form-control" disabled :value="transferTask.version" />
        </div>
        <div class="form-group col-12 col-md-6">
          <label>GL</label>
          <input type="text" class="form-control" disabled :value="transferTask.gl" />
        </div>
        <div class="form-group col-12 text-right">
          <b-button variant="secondary mr-2" type="button" @click="$bvModal.hide('modal-transfer')">Cancel</b-button>
          <b-button variant="primary" type="button" @click="confirmTransfer">Transfer</b-button>
        </div>
      </div>
    </b-modal>
    <ModalNotification
      @hide-modal="hideModalNotification"
      @approve-disapprove="submitApproveDisapprove"
      ref="modalNotification"
      :department="departmentName"
      :listDepartment="[]"
      :type="notificationType"
      :recipients="notificationRecipients"
      :plan="detail"
      :reason="approveDisapprovePayload.reason"
    />
  </div>
</template>

<script>
import axiosIns from '@/api/axios';
import moment from 'moment';
import ModalNotification from '@/views/budgetPlan/components/ModalNotification.vue';

export default {
  components: {
    ModalNotification,
  },
  computed: {
    detail() {
      return this.$store.getters['budgetPlan/detail'] || null;
    },
    departmentName() {
      return this.detail.fund_center?.department_name;
    },
    listUser() {
      let data = this.$store.getters['role/listData'].data;
      let after = data.filter((e) => e.roles_id == '4');
      return after;
    },
    budgetPlanTotal() {
      return `RP. ${this.convertNumber(parseFloat(this.detail?.capex_total) + parseFloat(this.detail?.opex_total)) || 0}`;
    },
    createdAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CREATE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'CREATE').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    createdBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CREATE')
          ? this.detail?.histories.find((e) => e.activity == 'CREATE')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    updatedAt() {
      return this.detail?.histories?.length > 0
        ? moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    updatedBy() {
      return this.detail?.histories?.length > 0 ? this.detail?.histories[0]?.user?.fullname || 'System' : 'System';
    },
    clonedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CLONE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'CLONE').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    clonedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CLONE')
          ? this.detail?.histories.find((e) => e.activity == 'CLONE')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    lockedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'LOCK')
          ? moment(this.detail?.histories.find((e) => e.activity == 'LOCK').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    lockedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'LOCK')
          ? this.detail?.histories.find((e) => e.activity == 'LOCK')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    approvedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'APPROVE')
          ? this.detail?.histories.find((e) => e.activity == 'APPROVE')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    approvedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'APPROVE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'APPROVE').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    disapprovedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'DISAPPROVE')
          ? this.detail?.histories.find((e) => e.activity == 'DISAPPROVE')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    disapprovedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'DISAPPROVE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'DISAPPROVE').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    canCloned() {
      return (
        this.detail?.locked &&
        this.detail?.version < 5 &&
        this.detail?.version >= this.detail?.all_version?.length &&
        (this.$store.getters['role/isSuperAdmin'] || this.$store.getters['role/isAdmin'])
      );
    },
    canLockUnlock() {
      return (
        (this.$store.getters['role/isSuperAdmin'] || this.$store.getters['role/isAdmin']) &&
        !this.detail?.all_version?.some((e) => e.version > this.detail?.version)
      );
    },
    canApprovedDissapproved() {
      return (
        (this.$store.getters['role/isSuperAdmin'] || this.$store.getters['role/isAdmin']) &&
        !this.detail?.all_version?.some((e) => e.version > this.detail?.version) &&
        (!this.detail?.all_version?.some((e) => e.approved == true) || this.detail?.all_version.find((e) => e.approved == true)?.id == this.detail.id)
      );
    },
    canTransferTask() {
      return this.detail?.fund_center_id != 3 && this.detail?.fund_center_id != 53 && !this.$store.getters['role/isViewer'];
    },
    listDepartment() {
      const departments = this.$store.getters['taskTransfer/listDepartment'] || [];
      if (departments?.length > 0) {
        return departments.filter((item) => item.id == 3 || item.id == 53);
      } else {
        this.$store.dispatch('taskTransfer/GET_LIST_DEPARTMENT');
      }
      return departments;
    },
    listPlan() {
      const data = this.$store.getters['budgetPlan/listData']?.data || [];
      return data;
    },
    filterDepartmentOptions() {
      const departments = [];
      for (const opex of this.detail?.opex) {
        for (const item of opex?.opex_item) {
          for (const task of item?.budget) {
            if (departments.some((e) => e.department_code == task?.origin_fund_center?.department_code)) continue;
            departments.push(task?.origin_fund_center);
          }
        }
      }
      console.log(departments);
      return departments;
    },
    listBudgetItems() {
      const tasks = this.listBudget?.budget || [];

      if (this.filter_fund_center) {
        return tasks?.filter((item) => item.origin_fund_center.id == this.filter_fund_center);
      }
      return tasks;
    },
  },
  data() {
    return {
      listBudget: '',
      listViewer: '',
      body: {
        search: '',
      },
      bodyShare: {
        entity_type: '',
        entity_id: '',
        user_id: '',
      },
      role_id: '',
      id: '',
      isLoading: false,
      transferTask: {
        fund_center_id: '',
        task_id: '',
        plan_id: '',
        version: '',
        gl: '6270051',
      },
      selectedPlan: null,
      filter_fund_center: '',
      approveDisapprovePayload: {
        id: '',
        reason: '',
      },
      notificationRecipients: [],
      notificationType: '',
    };
  },
  mounted() {
    this.getDetail();
    this.getListUser();
    this.role_id = localStorage.getItem('roles');
  },
  methods: {
    async getDetail() {
      const id = this.$router.currentRoute.query.id;
      await this.$store.dispatch('budgetPlan/GET_BUDGET_DETAIL', id);
      this.id = id;
    },
    getListUser() {
      let body = {
        search: this.body.search,
      };
      this.$store.dispatch('role/GET_LIST_DATA', body);
    },
    detailBudget(item) {
      this.listBudget = item;
      setTimeout(() => {
        this.$bvModal.show('modalBudget');
      }, 500);
    },
    convertNumber(dat) {
      return parseInt(dat)
        .toString()
        .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    },
    sharePlan(id, type) {
      (this.bodyShare.entity_id = id), (this.bodyShare.entity_type = type);
      axiosIns.get(`${axiosIns.defaults.baseURL}/users/viewer/${this.bodyShare.entity_type}/${this.bodyShare.entity_id}`).then((resp) => {
        this.listViewer = resp.data.data;
        this.$bvModal.show('modal-share');
      });
    },
    shares(id) {
      this.bodyShare.user_id = id;
      setTimeout(() => {
        this.$store.dispatch('role/SHARE_BUDGET_PLAN', this.bodyShare).then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', this.$swal.stopTimer);
                toast.addEventListener('mouseleave', this.$swal.resumeTimer);
              },
            })
            .fire({
              icon: 'success',
              title: 'Action Success',
            });
          axiosIns.get(`${axiosIns.defaults.baseURL}/users/viewer/${this.bodyShare.entity_type}/${this.bodyShare.entity_id}`).then((resp) => {
            this.listViewer = resp.data.data;
          });
        });
      }, 100);
    },
    unshares(id) {
      // this.bodyShare.user_id = id
      setTimeout(() => {
        this.$store.dispatch('role/UNSHARE_BUDGET_PLAN', id).then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', this.$swal.stopTimer);
                toast.addEventListener('mouseleave', this.$swal.resumeTimer);
              },
            })
            .fire({
              icon: 'success',
              title: 'Action Success',
            });
          axiosIns.get(`${axiosIns.defaults.baseURL}/users/viewer/${this.bodyShare.entity_type}/${this.bodyShare.entity_id}`).then((resp) => {
            this.listViewer = resp.data.data;
          });
        });
      }, 100);
    },
    cloning() {
      let payload = {
        id: this.id,
        body: this.detail,
      };
      this.$swal({
        title: `Are you sure to clone this budget plan to version ${parseInt(this.detail.version) + 1}?`,
        text: `This budget will be updated to version ${parseInt(this.detail.version) + 1} and no longer available for editing.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, clone it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.$store
            .dispatch('budgetPlan/UPDATE_VERSIONING', payload)
            .then((resp) => {
              this.$swal('Cloned!', `Budget plan has been cloned to version ${parseInt(this.detail.version) + 1}`, 'success');
              this.isLoading = false;
              this.$router
                .push({
                  name: 'budget_plan_detail',
                  query: {
                    id: resp.data.data.id,
                  },
                })
                .then(() => {
                  this.getDetail();
                  this.isLoading = false;
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal('Error', `${err.response.data.error}`, 'error');
                });
            })
            .catch((err) => {
              // This will catch any error from the API call
              console.log('Error during cloning:', err);
              this.$swal('Error', `${err.response.data.error || 'An error occurred while clone this budget plan'}`, 'error');
              this.isLoading = false;
            });
        }
      });
    },
    goToDetail(id) {
      this.isLoading = true;
      this.$router
        .push({
          name: 'budget_plan_detail',
          query: { id },
        })
        .then(() => {
          this.getDetail()
            .then(() => {
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        });
    },
    historyBack() {
      this.$router.push({
        name: 'budget_plan',
      });
    },
    async toogleLock(id, isLocked) {
      const warningText = isLocked
        ? 'This budget plan will be unlocked and available for editing'
        : 'This budget plan will be locked for editing and available to clone';

      const title = isLocked ? 'Are you sure to unlock this budget plan?' : 'Are you sure to lock this budget plan?';
      this.$swal({
        title,
        text: warningText,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: "Yes, I'm sure!",
        cancelButtonText: 'Cancel',
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch('budgetPlan/LOCK_BUDGET_PLAN', { id })
            .then((resp) => {
              this.isLoading = true;
              this.getDetail();
              this.$swal
                .mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer);
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                  },
                })
                .fire({
                  icon: 'success',
                  title: resp.data.message || 'Success locked budget plan',
                });
              this.isLoading = false;
            })
            .catch((error) => {
              this.$swal({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.error || 'Error while locking budget plan',
              });
            });
        }
      });
    },
    async toogleApprove(id, isDisapproved) {
      const warningText = isDisapproved
        ? 'This budget plan will be dissapproved, unlocked and available for editing'
        : 'This budget plan will be approved,locked for editing and available to clone';

      const title = isDisapproved ? 'Are you sure to dissapprove this budget plan?' : 'Are you sure to approve this budget plan?';
      this.notificationType = isDisapproved ? 'disapprove' : 'approve';
      this.$swal({
        title,
        text: warningText,
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: '#2F82FFFF',
        cancelButtonColor: '#E63757',
        denyButtonColor: '#00D97E',
        confirmButtonText: isDisapproved ? 'Disapprove with notification' : 'Approve with notification',
        denyButtonText: isDisapproved ? 'Disapprove' : 'Approve',
        cancelButtonText: 'Cancel',
        input: isDisapproved ? 'textarea' : '',
        inputPlaceholder: 'Write reason for disapprove budget plan',
        returnInputValueOnDeny: isDisapproved,
        inputValidator: (value) => {
          if (!value && isDisapproved) {
            return 'Please give reason for disapprove budget plan';
          }
        },
        preDeny: (value) => {
          if (!value && isDisapproved) {
            this.$swal.showValidationMessage('Please give reason for disapprove budget plan');
            return;
          }
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.approveDisapprovePayload.id = id;
          this.approveDisapprovePayload.reason = result.value === true ? '' : result.value;
          await this.showModalNotification();
        }
        if (result.isDenied) {
          this.approveDisapprovePayload.id = id;
          this.approveDisapprovePayload.reason = result.value === true ? '' : result.value;
          await this.submitApproveDisapprove();
        }
      });
    },
    async submitApproveDisapprove() {
      await this.$store
        .dispatch('budgetPlan/APPROVE_BUDGET_PLAN', this.approveDisapprovePayload)
        .then((resp) => {
          this.isLoading = true;
          this.getDetail();
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', this.$swal.stopTimer);
                toast.addEventListener('mouseleave', this.$swal.resumeTimer);
              },
            })
            .fire({
              icon: 'success',
              title: resp.data.message || 'Success approved budget plan',
            });
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.error || 'Error while approving budget plan',
          });
        });
    },
    selectFundCenter() {
      this.getListPlan();
      this.transferTask.plan_id = '';
      this.transferTask.version = '';
      this.selectedPlan = null;
    },
    selectPlan() {
      this.transferTask.plan_id = this.selectedPlan?.id;
      this.transferTask.version = `Year: ${this.selectedPlan?.year} - Version: ${this.selectedPlan?.version}`;
    },
    transfer(id) {
      this.transferTask.task_id = id;
      this.$bvModal.show('modal-transfer');
    },
    getListPlan() {
      this.$store.dispatch('budgetPlan/GET_LIST_DATA', {
        pageNumber: 1,
        pageSize: 100,
        search: '',
        field: '',
        order: '',
        dept: this.transferTask.fund_center_id,
      });
    },
    resetTransferTask() {
      this.transferTask = {
        fund_center_id: '',
        task_id: '',
        plan_id: '',
        version: '',
        gl: '6270051',
      };
      this.selectedPlan = null;
    },
    async confirmTransfer() {
      const validate = await this.$validator.validateAll();
      if (!validate) return;
      await this.$swal({
        title: 'Are you sure to transfer?',
        text: 'Task will be transfered to another budget plan',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, transfer it!',
        cancelButtonText: 'Cancel',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.$store
            .dispatch('taskTransfer/TRANSFER_TASK', this.transferTask)
            .then((resp) => {
              this.$swal('Success', resp.data.message, 'success');
              this.$bvModal.hide('modal-transfer');
              this.listBudget.budget = this.listBudget.budget.filter((item) => {
                return item.id !== this.transferTask.task_id;
              });
              this.$swal('Success', 'Task has been transfered', 'success');
              this.resetTransferTask();
              this.calculateSummaryAfterTransfer();
              if (this.listBudget.budget.length == 0) {
                this.$bvModal.hide('modalBudget');
              }
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.error || 'Error while transfering task',
              });
            });
        }
      });
    },
    filterDepartmentTask(evt) {
      const id = evt.target.value;
      this.listBudget.budget = this.listBudget.budget.filter((item) => {
        return item.fund_center_id == id;
      });
    },
    // check1(e) {
    //   for (let i = 0; i < e.opex; i++) {
    //     for (let x = 0; x < e.opex[i].opex_item; x++) {
    //       // const element = array[x];
    //       return e.opex[i].opex_item[x]

    //     }

    //   }
    // }
    calculateSummaryAfterTransfer() {
      let summary = {
        jan: BigInt(0),
        feb: BigInt(0),
        mar: BigInt(0),
        apr: BigInt(0),
        may: BigInt(0),
        jun: BigInt(0),
        jul: BigInt(0),
        aug: BigInt(0),
        sep: BigInt(0),
        oct: BigInt(0),
        nov: BigInt(0),
        dec: BigInt(0),
        total: BigInt(0),
      };
      for (let i = 0; i < this.listBudget.budget.length; i++) {
        summary.jan += BigInt(this.listBudget.budget[i].jan);
        summary.feb += BigInt(this.listBudget.budget[i].feb);
        summary.mar += BigInt(this.listBudget.budget[i].mar);
        summary.apr += BigInt(this.listBudget.budget[i].apr);
        summary.may += BigInt(this.listBudget.budget[i].may);
        summary.jun += BigInt(this.listBudget.budget[i].jun);
        summary.jul += BigInt(this.listBudget.budget[i].jul);
        summary.aug += BigInt(this.listBudget.budget[i].aug);
        summary.sep += BigInt(this.listBudget.budget[i].sep);
        summary.oct += BigInt(this.listBudget.budget[i].oct);
        summary.nov += BigInt(this.listBudget.budget[i].nov);
        summary.dec += BigInt(this.listBudget.budget[i].dec);
        summary.total += BigInt(this.listBudget.budget[i].total);
      }
      this.listBudget.summary = summary;
    },
    async getUserEmailByDepartment() {
      const response = await this.$store.dispatch('budgetPlan/GET_USER_BY_DEPARTMENT', {
        department: this.detail.fund_center?.id,
      });

      if (response.length == 0) {
        this.$swal({
          title: 'Warning',
          text: `No user found in "${this.detail.fund_center?.department_name}" to send notification`,
          icon: 'warning',
          confirmButtonText: 'OK',
        });
      }
      this.notificationRecipients = response?.map((item) => item.email);
    },
    showModalNotification() {
      this.getUserEmailByDepartment().then(() => {
        setTimeout(() => {
          this.$bvModal.show('modal-notification');
        }, 200);
      });
    },
    hideModalNotification() {
      this.$bvModal.hide('modal-notification');
    },
    getRelocateValue(code, month, unformated = false) {
      const relocateValue =
        this.detail.im_relocates
          ?.filter((item) => item.code_plan_budget === code && item.month === month)
          .reduce((acc, item) => acc + Number(item.relocate_value), 0) || 0;
      if (unformated) return relocateValue;
      return relocateValue > 0 ? `+ Rp. ${this.convertNumber(relocateValue)}` : '';
    },
  },
};
</script>

<style>
.bg-gray {
  background: #dad9d9 !important;
}

.tables-budget td:first-child,
.tables-budget td:nth-last-child(3),
.tables-budget td:nth-last-child(2),
.tables-budget td:last-child {
  /* text-align: center; */
}

.tables-budget > :not(caption) > * > * {
  padding: 0.5rem !important;
}

/* th:first-child+th+th,
  td:first-child+td+td {
    position: sticky;
    left: 0px;
    z-index: 3;
  } */

/* .opex-first th:first-child+th+th,
  .opex-first td:first-child+td+td {
    position: sticky;
    left: 0px;
    z-index: 3;
  }
  .capex th:first-child+th+th,
  .capex td:first-child+td+td {
    position: sticky;
    left: 0px;
    z-index: 3;
  }

  .capex-gl th:first-child+th+th,
  .capex-gl td:first-child+td+td {
    position: sticky;
    left: 0px;
    z-index: 3;
  }

  .capex td:first-child + td + td {
    background-color: #fff !important;
  }

  .opex td:first-child + td + td {
    background-color: #fff !important;
  } */
</style>
